module.exports = __webpack_public_path__ + "media/images/athletes/1752-a5b902e63e87791de80dd6353dd88709.png";